<template>
    <v-container class="login-page-wrapper w-100 h-100" ma-0 pa-0>
        <div class="d-flex h-100">
            <v-col class="h-100 p-0 carousel-wrapper" cols="12" md="5" sm="5">
                <div class="d-flex flex-column h-100 mx-auto justify-content-center align-items-center">
                    <div class="mb-5">
                        <v-img class="carousel-wrapper-logo" src="/images/britannia-logo.png" width="200px"></v-img>
                    </div>
                </div>
            </v-col>
            <v-col class="h-100 p-0 carousel-component" cols="12" md="7" sm="7">
                <v-row class="d-flex justify-center login-form-wrapper h-100 align-content-center align-items-center">
                    <v-col class="px-xl-0" cols="12" lg="10" xl="7">
                        <v-card outlined class="login-screen">
                            <v-card-text>
                                <div class="login-logo">
                                    <img src="/images/logo/denzapine-logo-large.png" />
                                </div>
                                <div class="login-title">
                                    <h1>
                                        {{
                                            forgotten
                                                ? t('login::title.forgotten_password')
                                                : t('login::title.set_password')
                                        }}
                                    </h1>
                                </div>
                                <div v-show="globalErrors.length">
                                    <v-alert v-for="(error, index) in globalErrors" :key="index" type="error"
                                        >{{ error }}
                                    </v-alert>
                                </div>
                                <div v-show="passwordUpdated">
                                    <v-alert type="success">{{ passwordUpdatedMessage }}</v-alert>
                                </div>
                                <v-form ref="form" v-model="valid" :rules="rules.title" lazy-validation>
                                    <v-text-field
                                        v-model="item.password"
                                        :error-messages="errorMessages.password"
                                        :label="t('reset_password::form.label.password')"
                                        :placeholder="t('reset_password::form.placeholder.password')"
                                        :rules="rules.password"
                                        :type="'password'"
                                        rounded
                                        outlined
                                        required
                                        class="medium"
                                        @keyup.enter="updatePassword"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="item.confirm_password"
                                        :error-messages="errorMessages.confirm_password"
                                        :label="t('reset_password::form.label.password_confirm')"
                                        :placeholder="t('reset_password::form.placeholder.password_confirm')"
                                        :rules="rules.confirm_password"
                                        :type="'password'"
                                        outlined
                                        rounded
                                        required
                                        class="medium"
                                        @keyup.enter="updatePassword"
                                    ></v-text-field>
                                    <div class="d-flex flex-wrap justify-content-between align-items-center mt-10">
                                        <v-btn
                                            :loading="loading"
                                            color="primary"
                                            rounded
                                            block
                                            large
                                            class="mb-7"
                                            @click="updatePassword"
                                        >
                                            {{ t('reset_password::form.button.update') }}
                                        </v-btn>

                                        <v-btn
                                            text
                                            rounded
                                            block
                                            large
                                            color="primary"
                                            @click.prevent="changeToLoginForm"
                                            >{{ t('login::button.reset.cancel') }}
                                        </v-btn>
                                    </div>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </div>
    </v-container>
</template>

<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    mixins: [formSubmitMixin],
    props: {
        updatePasswordRoute: {
            type: String,
            required: true,
        },
        email: {
            type: String,
            required: true,
        },
        token: {
            type: String,
            required: true,
        },
        forgotten: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            item: {
                password: null,
                confirm_password: null,
            },
            valid: true,
            loading: false,
            rules: {
                password: [(v) => !!v || t('reset_password::validation.password.required')],
                confirm_password: [
                    (v) => !!v || t('reset_password::validation.password_confirm.required'),
                    (p) => p === this.item.password || t('reset_password::validation.password_confirm.not_match'),
                ],
            },
            errorMessages: {
                password: [],
                confirm_password: [],
            },
            globalErrors: [],
            passwordUpdated: false,
            passwordUpdatedMessage: null,
        };
    },
    watch: {
        'errorMessages.password': {
            handler: _.debounce(function (val) {
                this.errorMessages.password = val.filter((x) => x);
            }),
        },
    },
    methods: {
        updatePassword() {
            var object = this;

            this.passwordUpdated = false;
            this.passwordUpdatedMessage = null;

            this.submit(
                this.updatePasswordRoute,
                {
                    password: this.item.password,
                    token: this.token,
                    email: this.email,
                },
                'post',
                function (result) {
                    object.passwordUpdated = true;
                    object.passwordUpdatedMessage = result.data.message;
                }
            );
        },
        changeToLoginForm() {
            window.location.href = route('auth.login');
        },
    },
};
</script>
